var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home center"},[_c('h3',{staticClass:"accent welcome"},[_vm._v(_vm._s(_vm.subname))]),_c('Logo',{attrs:{"width":"350px"}}),_c('Donate'),_c('ProjectLink'),_c('Credits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }